import {openResourceModal} from '../../core/modalCommand';
import {reportActiveAgentModalLifecycle} from '../../core/modalLifecycle';
import {
	SSID_SCHEDULE_EDIT_MODAL_EVENT,
	SSID_SCHEDULE_CREATE_MODAL_EVENT,
	SSID_SCHEDULE_DELETE_MODAL_EVENT,
} from './events';

/**
 * Open the Add SSID Schedule form.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSsidScheduleCreateModal(command, envelope) {
	return openResourceModal(
		SSID_SCHEDULE_CREATE_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open the Edit SSID Schedule form.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSsidScheduleEditModal(command, envelope) {
	return openResourceModal(
		SSID_SCHEDULE_EDIT_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open the SSID Schedule delete confirmation.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openSsidScheduleDeleteModal(command, envelope) {
	return openResourceModal(
		SSID_SCHEDULE_DELETE_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Report an SSID Schedule modal outcome.
 * @param {'modal.cancelled'|'modal.saved'} eventType lifecycle event
 * @return {Promise<object|null>} agent response
 */
export function reportSsidScheduleModalLifecycle(eventType) {
	return reportActiveAgentModalLifecycle(eventType);
}
